import * as React from "react";
import { AppState } from "../Store/RootReducer";
import { StreamingTradingAccountResources } from "./StreamingTradingAccountResources";
import { TradingAccountResources } from "./TradingAccountResources";
import { connect } from "react-redux";

interface PropsFromState {
  activeTradingAccountKey: string;
}

interface Props extends PropsFromState {
  bordered?: boolean;
  className?: string;
}

class ActiveTradingAccountStreamingResourcesCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <StreamingTradingAccountResources groupKey={this.props.activeTradingAccountKey}>
        {(currency, tradingAccountResources) => <TradingAccountResources tradingAccountResources={tradingAccountResources} currency={currency} className="platform-bar" bordered={false} />}
      </StreamingTradingAccountResources>
    )
  }
}

const mapStateToProps = (state: AppState): PropsFromState => ({
  activeTradingAccountKey: state.activeTradingAccount.account!.Key
});

export const ActiveTradingAccountStreamingResources = connect(mapStateToProps)(ActiveTradingAccountStreamingResourcesCmp);
